import { defineComponent } from 'vue';
import { generateColor } from '../util';
/** Preset swatches. Exposed via panelRender `components.Presets`. */
export default defineComponent({
    name: 'AColorPickerPresets',
    props: {
        prefixCls: { type: String, required: true },
        presets: { type: Array },
        disabled: Boolean,
    },
    emits: ['change', 'changeComplete'],
    setup(props, { emit }) {
        const onPresetClick = (c) => {
            if (props.disabled)
                return;
            const next = generateColor(c);
            emit('change', next);
            emit('changeComplete', next);
        };
        return () => {
            var _a;
            if (!((_a = props.presets) === null || _a === void 0 ? void 0 : _a.length))
                return null;
            const pre = props.prefixCls;
            return (<div class={`${pre}-presets`}>
          {props.presets.map((group, gi) => {
                    var _a;
                    return (<div class={`${pre}-presets-group`} key={(_a = group.key) !== null && _a !== void 0 ? _a : gi}>
              {group.label != null && (<div class={`${pre}-presets-label`}>{group.label}</div>)}
              <div class={`${pre}-presets-colors`}>
                {group.colors.map((c, ci) => {
                            const color = generateColor(c);
                            return (<div key={ci} class={`${pre}-presets-color`} style={{ background: color.toRgbString() }} onClick={() => onPresetClick(c)}/>);
                        })}
              </div>
            </div>);
                })}
        </div>);
        };
    },
});
